import {
  Component,
  ChangeDetectionStrategy,
  Input,
  OnInit,
} from '@angular/core';

import { Observable } from 'rxjs';

import {
  IGradeUnitDayListItemDTO,
  GradeUnitDayListItemDTO,
} from '@models/grade-unit/grade-unit-day';
import { IPermissionCheck } from '@models/role';
import { UserStateService } from '@core/services/state/user-state.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-grade-unit-day',
  template: `
    <app-grade-unit-day-presentation
      [checkPermission]="checkPermission$ | async"
      [pageDetails]="pageDetails"
      [gradeUnitDay]="gradeUnitDay"
      (emitNavigateToDayItem)="navigateToDayItem($event)"
    ></app-grade-unit-day-presentation>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GradeUnitDaySmartComponent implements OnInit {
  @Input() public gradeUnitDay: IGradeUnitDayListItemDTO =
    new GradeUnitDayListItemDTO();
  @Input() public dayNumber: number;
  @Input() public pageDetails: string;
  @Input() public pageText: string;

  public checkPermission$: Observable<IPermissionCheck>;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private userStateService: UserStateService,
  ) {}

  public ngOnInit(): void {
    this.checkPermission$ = this.checkUserPermissions();
    this.pageDetails = this.determinePageDetails();
  }

  public navigateToDayItem(dayNumber: number): void {
    this.router.navigate([dayNumber, 'blocks', 'update'], {
      relativeTo: this.activatedRoute,
      queryParams: { dayId: this.gradeUnitDay.dayId },
    });
  }

  private determinePageDetails() {
    if (this.gradeUnitDay.isQuiz) {
      return 'Assessment';
    } else {
      if (this.gradeUnitDay.dayStartPage && this.gradeUnitDay.dayEndPage) {
        return this.truncateText(
          `PAGES ${this.gradeUnitDay.dayStartPage} - ${this.gradeUnitDay.dayEndPage}`,
        );
      } else if (this.gradeUnitDay.dayEndPage) {
        return this.truncateText(`PAGE ${this.gradeUnitDay.dayStartPage}`);
      } else {
        return '';
      }
    }
  }

  private checkUserPermissions(): Observable<IPermissionCheck> {
    return this.userStateService.checkUserPermissions();
  }

  // for Admin user only
  public truncateText(pageText: string): string {
    if (pageText.length <= 25) {
      return pageText;
    }
    return pageText.substring(0, 25) + '...';
  }
}
